import { ReactNode } from "react";

export const LoadingOverlay = ({
  children,
  isLoading,
}: {
  children?: ReactNode;
  isLoading: boolean;
}) => {
  return (
    <>
      {children}
      {isLoading && (
        <div className="fixed bottom-0 left-0 right-0 top-0 z-[10000] flex h-full w-full items-center justify-center">
          <div className="z-20 h-7 w-7 animate-spin rounded-full border-4 border-gray-100 border-t-th-primary-900" />
          <div className="fixed bottom-0 left-0 right-0 top-0 z-10 flex h-full w-full items-center justify-center bg-black opacity-5"></div>
        </div>
      )}
    </>
  );
};
